module.exports = __webpack_public_path__ + "fonts/EMprint-SemiboldItalic.44bfa598.ttf";